import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as styles from './range-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class RangeItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onClick = this.onClick.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.renderHiddenInput = this.renderHiddenInput.bind(this);
  }
  componentDidMount() {
    this.isTouched = false;
  }
  onTouchStart() {
    this.isTouched = true;
  }
  onMouseEnter() {
    if (!this.isTouched) {
      this.setState({
        isHovered: true
      });
      this.props.onMouseEnter();
    }
  }
  onMouseLeave() {
    if (!this.isTouched) {
      this.setState({
        isHovered: false
      });
      this.props.onMouseLeave();
    }
  }
  onClick() {
    this.props.onClick();
  }
  isSelected() {
    return this.props.selectedPosition !== 'none';
  }
  renderLabel() {
    if (this.isSelected() || this.state.isHovered) {
      return this.props.hoverLabel;
    }
    return this.props.label;
  }
  renderHiddenInput() {
    if (!this.props.hiddenInputId) {
      return null;
    }
    var isLastSelected = this.props.selectedPosition === 'last' || this.props.selectedPosition === 'single';
    var isExtendingRight = this.props.isExtendingToRight && !this.isSelected();
    var relativePosition = isLastSelected || isExtendingRight ? 'maximum' : 'minimum';
    return ___EmotionJSX("input", {
      id: this.props.hiddenInputId,
      name: this.props.hiddenInputId,
      value: this.props.hiddenInputValue,
      type: "checkbox",
      css: styles.hiddenCheckbox,
      className: "range-selector__hidden-checkbox",
      readOnly: true,
      checked: this.isSelected() ? 'checked' : '',
      "aria-label": "Set ".concat(relativePosition, " ").concat(this.props.rangeName, " as ").concat(this.props.label)
    });
  }
  render() {
    // A simple truthy/falsey defensive check will resolve '0' as falsey and return an empty string.
    // This check will render 0 but not undefined or null
    var count = typeof this.props.count === 'number' ? "(".concat(this.props.count, ")") : '';
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
      ___EmotionJSX("li", {
        className: classnames('range-selector__item', {
          'is-selected': this.isSelected(),
          'is-last-selected': this.props.selectedPosition === 'last' || this.props.selectedPosition === 'single',
          'is-extending': this.props.isExtending && !this.isSelected(),
          'is-extending-right': this.props.isExtendingToRight && !this.isSelected()
        }),
        css: styles.item({
          isSelected: this.isSelected(),
          isLastSelected: this.props.selectedPosition === 'last' || this.props.selectedPosition === 'single',
          isFirstSelected: this.props.selectedPosition === 'first',
          isExtending: this.props.isExtending && !this.isSelected(),
          isExtendingRight: this.props.isExtendingToRight && !this.isSelected()
        }),
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onFocus: this.onMouseEnter,
        onBlur: this.onMouseLeave,
        onTouchStart: this.onTouchStart
      }, this.renderHiddenInput(), ___EmotionJSX("span", {
        css: styles.link,
        className: "range-selector__link"
      }, this.renderLabel()), ___EmotionJSX("span", {
        css: styles.label,
        className: "range-selector__label"
      }, count))
    );
  }
}
RangeItem.propTypes = {
  label: PropTypes.string.isRequired,
  hoverLabel: PropTypes.string.isRequired,
  selectedPosition: PropTypes.oneOf(['none', 'first', 'last', 'middle', 'single']),
  isExtending: PropTypes.bool,
  isExtendingToRight: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  count: PropTypes.number,
  hiddenInputId: PropTypes.string,
  hiddenInputValue: PropTypes.string,
  rangeName: PropTypes.string.isRequired
};
RangeItem.defaultProps = {
  selectedPosition: 'none',
  isExtending: false,
  isExtendingToRight: false,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  count: null,
  hiddenInputId: '',
  hiddenInputValue: ''
};
export default RangeItem;